import { motion } from "framer-motion";
import { EASE } from "@/lib/motion";
import MaskLines from "@/components/MaskLines";

const STEPS = [
  { key: "01", title: "Vertel ons je plan", text: "Wat mag blijven? Wat mag weg? We bespreken de ruimte en bereikbaarheid." },
  { key: "02", title: "Heldere offerte", text: "Arbeid, vervoer en eventuele afvoer staan vooraf in de afspraak." },
  { key: "icon", icon: "/assets/icon-4.png", title: "Samen keuzes maken", text: "Jij bepaalt wat blijft. We sorteren, dragen en ruimen zorgvuldig uit." },
  { key: "icon", icon: "/assets/icon-5.png", title: "Netjes opleveren", text: "We laten de afgesproken ruimte leeg en bezemschoon achter." },
];

export default function Process() {
  return (
    <section id="werkwijze" className="section process" data-testid="werkwijze">
      <MaskLines lines={["Van vol naar vrij."]} testId="werkwijze-titel" />
      <div className="steps">
        {STEPS.map((step, i) => (
          <motion.article
            key={step.title}
            className="step"
            initial={{ opacity: 0, y: 10 + i * 2 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.45, delay: i * 0.05, ease: EASE }}
            data-testid={`step-card-${i + 1}`}
          >
            <span className="step-number">
              {step.icon ? <img src={step.icon} alt="" width="40" height="40" /> : step.key}
            </span>
            <h3>{step.title}</h3>
            <p>{step.text}</p>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
